import { IChartApi } from 'lightweight-charts';

export type CrosshairElements = {
  line: HTMLDivElement;
  label: HTMLDivElement;
};

export const createCrosshairElements = (): CrosshairElements => {
  const line = document.createElement('div');
  line.dataset.crosshairSync = 'time-line';
  line.style.position = 'absolute';
  line.style.width = '1px';
  line.style.height = '100%';
  line.style.top = '0';
  line.style.background =
    'repeating-linear-gradient(to bottom, rgba(117, 134, 150, 0.5) 0%, rgba(117, 134, 150, 0.5) 50%, transparent 50%, transparent 100%)';
  line.style.backgroundSize = '1px 6px';
  line.style.pointerEvents = 'none';
  line.style.display = 'none';
  line.style.zIndex = '1000';

  const label = document.createElement('div');
  label.dataset.crosshairSync = 'time-label';
  label.style.position = 'absolute';
  label.style.backgroundColor = 'rgba(51, 51, 51, 0.9)';
  label.style.color = 'white';
  label.style.padding = '2px 4px';
  label.style.fontSize = '12px';
  label.style.fontFamily = 'Helvetica, Arial, sans-serif';
  label.style.borderRadius = '2px';
  label.style.pointerEvents = 'none';
  label.style.display = 'none';
  label.style.zIndex = '1001';
  label.style.whiteSpace = 'nowrap';

  return { line, label };
};

export const attachCrosshairElements = (
  chart: IChartApi,
  elements: CrosshairElements
) => {
  chart.chartElement().appendChild(elements.line);
  chart.chartElement().appendChild(elements.label);
};

export const removeCrosshairElements = (
  chart: IChartApi,
  elements: CrosshairElements
) => {
  chart.chartElement().removeChild(elements.line);
  chart.chartElement().removeChild(elements.label);
};

export const updateCrosshairPosition = (
  elements: CrosshairElements,
  xPos: number | null,
  time?: number
) => {
  if (xPos !== null && time !== undefined) {
    elements.line.style.left = `${xPos}px`;
    elements.line.style.display = 'block';
    elements.label.style.left = `${xPos + 5}px`;
    elements.label.style.top = '10px';
    elements.label.textContent = new Date(time * 1000).toLocaleString();
    elements.label.style.display = 'block';
  } else {
    elements.line.style.display = 'none';
    elements.label.style.display = 'none';
  }
};
